import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import { AIFormattedText } from '../components/AIFormattedText';
import Loading from '../components/Loading';
import FileUploader from '../components/FileUploader';
import ConsoleLogs from '../components/ConsoleLogs';
import { formatTimeStamp } from '../utils/Helpers';
import { useTakeOffs } from '../context/TakeOffContext';
import axios from 'axios';
import ImageMagnifier from '../components/ImageMagnifier';

function TakeOff() {
  const { takeOffs, loading, submitNewTakeoff } = useTakeOffs();
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [waitingOpenAI, setWaitingOpenAi] = useState(true)
  const [serverResponse, setServerResponse] = useState({});
  const [textResponse, setTextResponse] = useState('');
  const [sidebar, setSidebar] = useState(true);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedJobsite, setSelectedJobsite] = useState(null);
  const [showOriginal, setShowOriginal] = useState(true)
  const [products, setProducts] = useState({
    Frames_6Hx4W: 0,
    Frames_5Hx4W: 0,
    Frames_4Hx4W: 0,
    Frames_inBox: 0,
    U_Heads: 0,
    Base_Plate: 0,
    Cross_Bars: 0,
    Shores: 0,
    Shores_sub: 0
  });

  const handleResponse = (res) => {
    if (res.length > 0) {
      setServerResponse(res[0]);
      sendTextToFormatter(res[0].text);
      setSidebar(false);
      setHasSubmitted(false); // Reset submission flag
    }
  };
  
  const sendTextToFormatter = async (scannedText) => {
    setWaitingOpenAi(true)
    if (!scannedText) return;
    try {
      const response = await axios.post(
        'https://open-ai-ttf.vercel.app/formatScannedPDF',
        { scannedText }
      );
      setTextResponse(response.data);
      setWaitingOpenAi(false)
    } catch (error) {
      console.error('Error sending text to AI formatter:', error);
      setTextResponse('Failed to format the extracted text.');
    }
  };

  const makeProductList = (objects) => {
    setProducts({
      Frames_6Hx4W: objects.frames6x4 * 2,
      Frames_5Hx4W: objects.frames5x4 * 2,
      Frames_4Hx4W: 0,
      Frames_inBox: objects.framesInBox * 2,
      U_Heads: (objects.frames6x4 + objects.frames5x4 + objects.framesInBox) * 2,
      Base_Plate: (objects.frames6x4 + objects.frames5x4 + objects.framesInBox) * 2,
      Cross_Bars: (objects.frames6x4 + objects.frames5x4 + objects.framesInBox) * 2,
      Shores_sub: objects.shoresBox,
      Shores: Math.floor((objects.shores - (objects.shoresBox * 4)) / 6),
    });
  };

  const handleSubmitTakeoff = async () => {
    let takeoffData = {
      created_at: new Date().toISOString(),
      company: selectedCompany,
      jobsite: selectedJobsite,
      data: {
        products,
        information: textResponse,
        fileName: serverResponse.file_name, 
        fileType: serverResponse.file_type, 
        fileSize: (serverResponse.size / (1024 * 1024)).toFixed(2), 
      },
    };

    console.log('SAVING TAKEOFF :');
    console.log(takeoffData);
    
    

    await submitNewTakeoff(takeoffData);
  };

  const renderProductList = () =>
    Object.entries(products).map(([key, value]) => (
      <div
        key={key}
        className="flex flex-row justify-between border-b border-gray-700 px-5 py-3 hover:bg-gray-700"
      >
        <b>{key.replace(/_/g, ' ')}:</b>
        <p>{value}</p>
      </div>
    ));

  useEffect(() => {
      if (
        serverResponse &&
        serverResponse.shape_count &&
        selectedCompany &&
        selectedJobsite &&
        !hasSubmitted
      ) {
        const scaffolds = serverResponse.shape_count.Scaffold6x4 || 0;
        const shores = serverResponse.shape_count.Shores || 0;
        const objects = serverResponse.colorObjects
        makeProductList(objects);
    
        // Submit and prevent further submissions
        handleSubmitTakeoff();
        setHasSubmitted(true);
      }
   }, [serverResponse, selectedCompany, selectedJobsite]);
      


  return (
    <div className="wrapper-orders">
      <Sidebar />
      <div className="content">
        <div className="header">
          <h1>TakeOff</h1> 
        </div>
        <div
          className={`${
            sidebar
              ? serverResponse?.file_name
                ? 'grid grid-cols-[20%_60%_20%]'
                : 'grid grid-cols-[20%_80%]'
              : serverResponse?.file_name
              ? 'grid grid-cols-[0_70%_30%]'
              : 'grid grid-cols-[0%_100%]'
          } border-t border-gray-700 mt-[20px] h-[calc(100vh-90px)]`}
        >
          {/* Sidebar */}
          <div
            className={`h-[calc(100vh-90px)] overflow-y-scroll border-gray-700 ${
              sidebar ? 'border-r' : ''
            }`}
          >
            {loading ? (
              <p>Loading takeoffs...</p>
            ) : takeOffs.length === 0 ? (
              <p className='mt-[40vh] text-gray-700'>No takeoffs found.</p>
            ) : (
              takeOffs.map((takeoff) => (
                <div
                  key={takeoff.id}
                  className="border-b border-gray-700 p-5 text-left grid grid-cols-[auto_10px] items-center hover:bg-gray-700"
                >
                  <div>
                    <p>
                      <b>Company:</b> {takeoff.company.toUpperCase()}
                    </p>
                    <p>
                      <b>Jobsite:</b> {takeoff.jobsite}
                    </p>
                    <p>
                      <b>Date Created:</b> {formatTimeStamp(takeoff.created_at)[0]}
                    </p>
                    {/* <p>
                      <b>Time Created:</b> {formatTimeStamp(takeoff.created_at)[1]}
                    </p> */}
                  </div>
                  <i className="bi bi-chevron-compact-right"></i>
                </div>
              ))
            )}
          </div>

          {/* File Viewer */}
          <div className="flex items-center justify-center relative p-5">
            <i
              className="bi bi-layout-sidebar absolute top-2 left-5 text-[30px] text-gray-700"
              onClick={() => setSidebar(!sidebar)}
            ></i>
            <i
              className={`bi bi-symmetry-vertical absolute top-2 right-5 text-[30px] text-gray-700 ${showOriginal ? 'text-gray-700' : 'text-primary'} ${serverResponse.processed_image_url ? 'block' : 'hidden'}`}
              onClick={() => setShowOriginal(!showOriginal)}
            ></i>
            {serverResponse?.processed_image_url ? (
              <ImageMagnifier src={`${!showOriginal ? serverResponse.processed_image_url : serverResponse.objectsImage}`}/>
            ) : (
              <div className="flex flex-col w-full">
                <FileUploader 
                  onResponse={handleResponse}
                  onCompanySelect={(company) => setSelectedCompany(company)}
                  onJobsiteSelect={(jobsite) => setSelectedJobsite(jobsite)}
                />
              </div>
            )}
          </div>

          {/* Takeoff Details */}
          {serverResponse?.file_name && (
            <div className="border-l border-gray-700 h-[calc(100vh-90px)] overflow-y-scroll">
              <div className="border-b border-gray-700 p-4">
                <p className="text-left">
                  <b>Company:</b> {selectedCompany.toUpperCase()}
                </p>
              </div>
              <div className="border-b border-gray-700 p-4">
                <p className="text-left">
                  <b>Jobsite:</b> {selectedJobsite}
                </p>
              </div>
              <div className="border-b border-gray-700 p-4">
                <p className="text-left">
                  <b>File Name:</b> {serverResponse.file_name}
                </p>
              </div>
              <div className="border-b border-gray-700 p-4">
                <p className="text-left">
                  <b>File Type:</b> {serverResponse.type}
                </p>
              </div>
              <div className="border-b border-gray-700 p-4">
                <p className="text-left">
                  <b>File Size:</b>{' '}
                  {(serverResponse.size / (1024 * 1024)).toFixed(2)} MB
                </p>
              </div>
              <div className="border-b border-gray-700 p-4">
                <p className="text-left">
                  <b>Shapes Count:</b>
                </p>
                {products ? renderProductList() : <p>No product data available.</p>}
              </div>
              <div className="border-b border-gray-700 p-4">
                {waitingOpenAI ? (
                  <div className="p-[10px] flex items-center gap-[20px]">
                    <Loading />
                    <p> Thinking ... </p>
                  </div>
                ) : (
                  <>
                    <AIFormattedText text={textResponse} />
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TakeOff;
